module.exports = __webpack_public_path__ + "static/yellowMan-a371e05556a0a5c9454b96e1e0b018b2.png";